import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginPage from "@/pages/LoginPage";
import NotesPage from "@/pages/NotesPage";
import { NotesProvider } from "@/lib/notesContext";
import { Toaster } from "sonner";
import { AppShell } from "@/components/AppShell";
import DashboardPage from "@/pages/DashboardPage";
import ManagePage from "@/pages/ManagePage";
import PickersPage from "@/pages/PickersPage";
import SummaryPage from "@/pages/SummaryPage";

const Gate = () => {
  const { user, isManager } = useAuth();
  if (user === null) return <div className="flex justify-center pt-40 text-slate-400" data-testid="auth-checking"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  if (!user) return <LoginPage />;
  return (
    <NotesProvider>
    <AppShell>
      <Routes>
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/" element={<DashboardPage />} />
        <Route path="/manage" element={isManager ? <ManagePage /> : <Navigate to="/" replace />} />
        <Route path="/pickers" element={<PickersPage />} />
        <Route path="/summary" element={<SummaryPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
    </NotesProvider>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0F19] text-slate-300 font-sans">
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
